<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const route = useRoute();
const auth = useAuthStore();
const taskTarget = computed(() => auth.user?.claimWhitelist === 1 ? '/' : '/latest-task');
</script>

<template>
  <nav class="bottom-nav" aria-label="底部导航">
    <RouterLink :to="taskTarget" :class="{ 'router-link-active': route.path === '/' }">
      <img class="nav-normal" src="/assets/tabbar/task.png" alt="" />
      <img class="nav-active" src="/assets/tabbar/task-active.png" alt="" />
      <span>任务</span>
    </RouterLink>
    <RouterLink to="/me/tasks">
      <img class="nav-normal" src="/assets/tabbar/orders.png" alt="" />
      <img class="nav-active" src="/assets/tabbar/orders-active.png" alt="" />
      <span>进度</span>
    </RouterLink>
    <RouterLink to="/me">
      <img class="nav-normal" src="/assets/tabbar/profile.png" alt="" />
      <img class="nav-active" src="/assets/tabbar/profile-active.png" alt="" />
      <span>我的</span>
    </RouterLink>
  </nav>
</template>

<style scoped>
.nav-active { display: none; }
.router-link-active .nav-normal { display: none; }
.router-link-active .nav-active { display: block; }
</style>
